import GlobalStoreService from "../services/global-store.service";
import { globalConstants } from "../constants/globalConstants";
import TrackingMiddlewareService from './tracking-middleware.service'
import TrackingKey from '../enums/trackingKey'

export default class IdleTimeoutService {

    static trackIdleChat() {

        // TRACK IDLE TIMEOUT
        const trackIdleEvent = setInterval(() => {
            if (!GlobalStoreService.get("trackingData").isIdleChatCallled && GlobalStoreService.get("trackingData").isIdleChat) {

                TrackingMiddlewareService.trackEvent(TrackingKey.IDLE_CHAT)

                const trackingData = GlobalStoreService.get("trackingData");
                trackingData.isIdleChatCallled = true;
                GlobalStoreService.set("trackingData", trackingData);
                clearInterval(trackIdleEvent);
            }

            const trackingData = GlobalStoreService.get("trackingData");
            trackingData.isIdleChat = true;
            GlobalStoreService.set("trackingData", trackingData);

        }, 1000 * 60 * 4);
    }

    static updateIdleState() {
        const trackingData = GlobalStoreService.get("trackingData");
        trackingData.isIdleChat = false;
        GlobalStoreService.set("trackingData", trackingData);
    }
}


// WEBPACK FOOTER //
// ./src/services/idle-timeout.service.js